import rotateLabel from './rotate-label';
export default rotateLabel;
